import forms from '../components/form';
import header from '../components/header';
// import pages from '../exports/pages';
import AOS from 'aos';
import ajax from '../exports/ajax'
// import {playSingleGame} from '../exports/events';


function toggleLoader(status = true) {
  let loader = $('.overlay.loading, .custom-loader');
  status ?  loader.addClass('active') :  loader.removeClass('active');
}

function getAllFilters() {
  let searchValue = document.querySelector('#search_game').value;
  let selectDataFilters = document.querySelectorAll('.custom-fitler-select .top span')
  let allDataFilters = []
  let markedFilters = {}
  selectDataFilters.forEach(el => {
    let dataType = el.getAttribute('data-type');
    let dataValue= el.getAttribute('data-type-value');
    if(el.hasAttribute('data-type') && el.hasAttribute('data-type-value')) {
      let res = {
        [dataType]:  dataValue,
      }
      allDataFilters = [...allDataFilters,...res]
    }
  })

  allDataFilters.map( el => {
    markedFilters = {
      ...markedFilters,...{[Object.keys(el)[0]]: el[Object.keys(el)[0]]},
    }
  })

  return {
    search_game: `${searchValue}`,
    ...markedFilters,
  }
}

function filterAjaxBody(method, data, el) {
  ajax(method, data, function (response) {
    if (response.success === true) {
      el.find('.filter-load-more').parent().remove()
      if (response.data.load_more === true) {
        el.append(response.data.view)
      } else {
        el.html(response.data.view);
      }
      animateResult();
    }
  })
}


function animateResult() {
  var interval = setInterval(function () {
    if ($('.filtered-listing-games-wrapper .box:not(.animate)').size() == 0) {
      clearInterval(interval);
    } else {
      $('.filtered-listing-games-wrapper .box:not(.animate)').first().addClass('animate');
    }
  }, 200);
}


let  getAjaxData = (ajaxData,that) =>  {
  let elToWhichToAppend = $('.jackpot-wrapper');
  if (that.data('next-page') !== undefined) {
    ajaxData.load_more = that.data('next-page');
    ajaxData.game_ids = that.data('game-ids');
    ajaxData.is_sorting = that.data('game-is-sorting');
  }

  ajax('POST', ajaxData, function (response) {
    // loading start
    toggleLoader();
    if (response.success === true) {
      if (response.data.load_more === true) {
        //loading end
        toggleLoader(false);
        elToWhichToAppend.parent().find('.filter-load-more-front').parent().remove();
        elToWhichToAppend.append(response.data.view);
      } else {
        //loading end
        toggleLoader(false);
        elToWhichToAppend.html(response.data.view);
      }
    }
  })
}

function filterGames(method) {
  let filtersOptions = document.querySelectorAll('.custom-fitler-select li');
  // let elToWhichToAppend = $('.jackpot-wrapper');
  if(method === 'filter_front_load_more_ajax'){
    $(document).on('click', '.filter-load-more-front', function () {
      let ajaxData = {
        action: method,
        game_instance: 'main_games',
        ...getAllFilters(),
      }

      getAjaxData(ajaxData,$(this));
    })

  } else if(method === 'filter_front_category_ajax') {
    filtersOptions.forEach(function (el) {
      el.addEventListener('click', function (e) {

        let type = e.target.getAttribute('data-type'),
          typeValue = e.target.getAttribute('data-type-value');
        if (e.target.getAttribute('data-type') === 'game_cat_new_type') {
          let ajaxData = {
            action: method,
            game_instance: 'main_games',
            ...getAllFilters(),
            ...{[type]: `${typeValue}`},
          }

          getAjaxData(ajaxData,$(this));
        }
      })
    })
  }else if(method === 'filter_front_jackpot_selection_ajax') {

      filtersOptions.forEach(function (el) {
        el.addEventListener('click', function (e) {

          let type = e.target.getAttribute('data-type'),
            typeValue = e.target.getAttribute('data-type-value');
          if (e.target.getAttribute('data-type') === 'jackpot') {
            let ajaxData = {
              action: method,
              game_instance: 'main_games',
              ...getAllFilters(),
              ...{[type]: `${typeValue}`},
            }

            getAjaxData(ajaxData,$(this));
          }
        })
      })
  } else if(method === 'filter_front_sort_by_ajax') {
    filtersOptions.forEach(function (el) {
      el.addEventListener('click', function (e) {
        let type = e.target.getAttribute('data-type'),
          typeValue = e.target.getAttribute('data-type-value');
        if (e.target.getAttribute('data-type') === 'sort_by') {
          let ajaxData = {
            action: method,
            game_instance: 'main_games',
            ...getAllFilters(),
            ...{[type]: `${typeValue}`},
          }

          getAjaxData(ajaxData, $(this));
        }
      })
    })
  } else if(method === 'filter_front_search_slot_games_ajax') {


 

    // $(document).on('keyup', '.filter-search-slot-games', function (e) {

      

    //   const MIN_SEARCH_LENGTH = 3;
    //   let searchValue = e.target.value;

    //   var saveChanges = {
    //     action: 'filter_search_slot_games_ajax',
    //     ...{search_game: `${searchValue}`},
    //      game_instance:  sessionStorage.getItem('game_instance') !== null ? JSON.parse(sessionStorage.getItem('game_instance')) : 'all_games',
    //     'jackpot_selection': JSON.parse(sessionStorage.getItem('jackpot_selection')),
    //     'certified_market': JSON.parse(sessionStorage.getItem('certified_market')),
    //     'category': JSON.parse(sessionStorage.getItem('category')),
    //     'social_games_main_cpt': 0,
    //   }

    //   let  ajaxData = {
    //     action: method,
    //     game_instance: 'main_games',
    //     ...getAllFilters(),
    //     ...{search_game: `${searchValue}`},
    //   }
    //   //add/change action on other filter_front_search_slot_games_ajax
    //   if (searchValue.length >= MIN_SEARCH_LENGTH) {
    //     getAjaxData(ajaxData,$(this));
    //     //var savetest = $.extend(saveChanges, ajaxData);
    //     filterAjaxBody('POST', saveChanges, $('.main-games-ch'));

    //   } else if (searchValue.length === 0) {
    //     getAjaxData(ajaxData,$(this));
    //   }
    // })
  }
}



export default {
  init() {
    /*
     *  Global stuff
     * */
    filterGames('filter_front_load_more_ajax');
    filterGames('filter_front_search_slot_games_ajax');
    filterGames('filter_front_category_ajax');
    filterGames('filter_front_jackpot_selection_ajax');
    filterGames('filter_front_sort_by_ajax');


    // img to svg
    $('img.svg').each(function () {
      var $img = jQuery(this);
      var imgID = $img.attr('id');
      var imgClass = $img.attr('class');
      var imgURL = $img.attr('src');
      $.get(
        imgURL,
        function (data) {
          var $svg = jQuery(data).find('svg');
          if (typeof imgID !== 'undefined') {
            $svg = $svg.attr('id', imgID);
          }
          if (typeof imgClass !== 'undefined') {
            $svg = $svg.attr('class', imgClass + ' replaced-svg');
          }
          $svg = $svg.removeAttr('xmlns:a');
          $img.replaceWith($svg);
        },
        'xml'
      );
    });
    $(document).ready(() => {
      header();
      forms();
      AOS.init({// offset (in px) from the original trigger point
        duration: 800, // values from 0 to 3000, with step 50ms
        easing: 'ease-in-out', // default easing for AOS animations
      });
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js